import { Component } from '@angular/core';
import { SnackBarService } from '../../../services/snack-bar.service';
import { ToastKind } from '../../../components/toast/toast.component';

interface TestCase {
  label: string;
  kind: ToastKind;
  title: string;
  description?: string;
}

@Component({
  selector: 'app-toast-test',
  templateUrl: './toast-test.component.html',
  styleUrl: './toast-test.component.scss',
})
export class ToastTestComponent {
  /** Every button on the test page — one per row so it's obvious what
   *  each variant looks like when actually rendered by MatSnackBar. */
  readonly cases: TestCase[] = [
    // ── success ────────────────────────────────────────────────
    {
      label: 'success · title only',
      kind: 'success',
      title: 'ההזמנה נוצרה בהצלחה',
    },
    {
      label: 'success · with description',
      kind: 'success',
      title: 'ההזמנה נוצרה בהצלחה',
      description: 'יואב מסאמי · פרשת חקת',
    },
    {
      label: 'success · long description',
      kind: 'success',
      title: 'משתמש נוסף בהצלחה',
      description:
        'שם: ישראל ישראלי · אימייל: israel@example.com · הרשאה: חבר ועד · צור קשר: 050-555-1234',
    },

    // ── error ──────────────────────────────────────────────────
    {
      label: 'error · title only',
      kind: 'error',
      title: 'שגיאה בהזנת ההזמנה',
    },
    {
      label: 'error · with description',
      kind: 'error',
      title: 'לא ניתן להוסיף משתמש',
      description: 'בדוק שכתובת האימייל תקינה ושהסיסמה בת 4 תווים לפחות.',
    },

    // ── warning ────────────────────────────────────────────────
    {
      label: 'warning · title only',
      kind: 'warning',
      title: 'יש לבחור פרשה או חג',
    },
    {
      label: 'warning · with description',
      kind: 'warning',
      title: 'שדות חסרים',
      description: 'טרם נבחר מתפלל וטרם הוזנה פרשה. השלם ואישור מחדש.',
    },

    // ── info ───────────────────────────────────────────────────
    {
      label: 'info · title only',
      kind: 'info',
      title: 'היתרה עודכנה',
    },
    {
      label: 'info · with description',
      kind: 'info',
      title: 'היתרה עודכנה',
      description:
        'יתרה חדשה למתפלל: ‎+₪120. הפעולה תופיע בהיסטוריה עם שמך.',
    },
  ];

  constructor(private snackBar: SnackBarService) {}

  fire(tc: TestCase): void {
    this.snackBar.openToast(tc.title, {
      kind: tc.kind,
      description: tc.description,
    });
  }

  /** Fire one of each kind in quick succession — verify stacking. */
  fireAll(): void {
    for (const tc of this.cases) {
      this.snackBar.openToast(tc.title, {
        kind: tc.kind,
        description: tc.description,
      });
    }
  }
}
